import { IconProps } from '@models/icons';

function MapPin({ size = 16, color, ...rest }:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path
                d="M8 1C11.3138 1 14 3.68619 14 7C14 7.98995 13.6518 9.27377 13.2217 10.0938C12.1249 12.1845 8 15.5 8 15.5C8 15.5 3.87508 12.1845 2.77832 10.0938C2.34823 9.27377 2 7.98995 2 7C2 3.68619 4.68619 1 8 1ZM8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5Z"
                fill={color}/>
        </svg>
    );
}

export default MapPin;
